var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2124_21464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.3748 49.5833L63.7498 38.9583H38.9582C38.0189 38.9583 37.118 38.5852 36.4538 37.921C35.7896 37.2568 35.4165 36.356 35.4165 35.4167V14.1667C35.4165 13.2274 35.7896 12.3265 36.4538 11.6623C37.118 10.9981 38.0189 10.625 38.9582 10.625H70.8332C71.7725 10.625 72.6733 10.9981 73.3375 11.6623C74.0017 12.3265 74.3748 13.2274 74.3748 14.1667V49.5833Z",
    stroke: "#A1A0A0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5833 53.1263V60.2096C49.5833 61.1489 49.2102 62.0498 48.546 62.714C47.8818 63.3782 46.981 63.7513 46.0417 63.7513H21.25L10.625 74.3763V38.9596C10.625 38.0203 10.9981 37.1195 11.6623 36.4553C12.3265 35.7911 13.2274 35.418 14.1667 35.418H21.25",
    stroke: "#A1A0A0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2124_21464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessages);
export default __webpack_public_path__ + "static/media/No-Messages.b106dafc4b9d3ee42d852514d481a679.svg";
export { ForwardRef as ReactComponent };